import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
export var TextMultiField = /*#__PURE__*/function (_Component) {
  _inherits(TextMultiField, _Component);

  var _super = _createSuper(TextMultiField);

  function TextMultiField() {
    var _this;

    _classCallCheck(this, TextMultiField);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.onEdit = function (index) {
      return function (event) {
        _this.props.onChange(event.target.value ? _this.props.value.set(index, event.target.value) : _this.props.value["delete"](index));
      };
    };

    _this.onAdd = function (event) {
      _this.props.onChange(_this.props.value.push(event.target.value));
    };

    _this.onRemove = function (index) {
      return function () {
        _this.props.onChange(_this.props.value["delete"](index));
      };
    };

    return _this;
  }

  _createClass(TextMultiField, [{
    key: "render",
    // When rendering the inputs we append an empty string to the list of values,
    // this is helpful because then the "new" input is in the keyed collection so
    // when text is entered there we get a smooth addition of another new input.
    value: function render() {
      var _this2 = this;

      return this.props.visible && /*#__PURE__*/React.createElement("div", {
        className: "field"
      }, /*#__PURE__*/React.createElement("h5", null, this.props.label), this.props.value.push('').map(function (selection, i) {
        return /*#__PURE__*/React.createElement("div", {
          key: i
        }, /*#__PURE__*/React.createElement("input", {
          type: "text",
          onBlur: _this2.props.onBlur,
          onChange: selection ? _this2.onEdit(i) : _this2.onAdd,
          onFocus: _this2.props.onFocus,
          placeholder: _this2.props.placeholder,
          value: selection
        }), selection && /*#__PURE__*/React.createElement("button", {
          type: "button",
          onFocus: _this2.props.onFocus,
          onBlur: _this2.props.onBlur,
          onClick: _this2.onRemove(i)
        }, "\xD7"));
      }));
    }
  }]);

  return TextMultiField;
}(Component);